export const navigationLinks = [
  { label: '首页', href: '/' },
  { label: '游戏分类', href: '/category' },
  { label: '最新资讯', href: '/articles' },
  { label: '关于我们', href: '/about' },
];

export const siteInfo = {
  name: '澳门新葡京',
  fullName: '澳门新葡京娱乐平台',
  slogan: '官方认证 · 安全可靠 · 畅享娱乐',
  description: '澳门新葡京app是澳门顶级娱乐平台官方应用，提供正版安全下载、极速流畅体验、多元游戏娱乐及专属会员福利。',
  phone: '+853 2888 8888',
  email: 'service@xinpujing.mo',
  address: '澳门半岛南湾大马路新葡京娱乐场',
  copyright: '© 2026 澳门新葡京娱乐平台 版权所有',
};